import reflectQueue from './reflectQueue';

export default function clearReflection(name) {
	let index = reflectQueue.indexOf(name);
	while (index !== -1) {
		reflectQueue.splice(index, 1);
		index = reflectQueue.indexOf(name);
	}

	return reflectQueue;
}
